import React from 'react';
import { Button } from '../ui/button';
import { FundingReadinessTierBadge } from './FundingReadinessScoreCard';
import FundingMatchFitTierBadge from './FundingMatchFitTierBadge';

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
  }).format(value);
};

const FundingMatchRunPanel = ({ client, onRunMatch, running }) => {
  if (!client) {
    return (
      <p className="text-sm text-[var(--fg-muted)]">
        Select a funding client to review profile signals before running lender matching.
      </p>
    );
  }

  return (
    <div className="space-y-4">
      <div>
        <div className="text-lg font-semibold text-[var(--fg-text)]">{client.name}</div>
        <div className="text-sm text-[var(--fg-muted)]">{client.businessName || client.legalBusinessName || 'Business profile'}</div>
      </div>

      <div className="grid gap-3 sm:grid-cols-2">
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Readiness tier</div>
          <div className="mt-1">
            {client.readinessTier ? <FundingReadinessTierBadge tier={client.readinessTier} /> : 'Not scored'}
          </div>
        </div>
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Document status</div>
          <div className="mt-1 text-sm text-[var(--fg-text)]">{client.documentStatus || 'Missing'}</div>
        </div>
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Requested amount</div>
          <div className="mt-1 text-sm text-[var(--fg-text)]">{formatCurrency(client.requestedAmount)}</div>
        </div>
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Credit score</div>
          <div className="mt-1 text-sm text-[var(--fg-text)]">{client.creditScore ?? '—'}</div>
        </div>
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Monthly revenue</div>
          <div className="mt-1 text-sm text-[var(--fg-text)]">{formatCurrency(client.monthlyRevenue)}</div>
        </div>
        <div className="rounded-xl border border-[var(--fg-line)] bg-[var(--fg-panel-soft)] px-3 py-2.5">
          <div className="text-[11px] font-semibold uppercase tracking-wide text-[var(--fg-muted)]">Use of funds</div>
          <div className="mt-1 text-sm text-[var(--fg-text)]">{client.useOfFunds || '—'}</div>
        </div>
      </div>

      <Button
        className="w-full rounded-xl bg-[var(--fg-accent)] hover:bg-[#126b4f]"
        onClick={onRunMatch}
        disabled={running}
        data-testid="funding-match-run"
      >
        {running ? 'Running match...' : 'Run Match'}
      </Button>
    </div>
  );
};

export default FundingMatchRunPanel;
